import React, { useState } from "react";
import ReactDatePicker from "react-datepicker";
import { months, years } from "../../Utils/Utils";

export const DateFilter = ({ filtrerChiffreAffaire, filtrerInstallation, filtrerStatCounter }) => {
    const date = new Date();

    const [dateRange, setDateRange] = useState([new Date(), new Date()]);
    const [startDate, endDate] = dateRange;
    const [selectPeriode, setSelectPeriode] = useState("MOIS");
    const [selectMois, setSelectMois] = useState(date.getMonth() + 1);
    const [selectAnnee, setSelectAnnee] = useState(date.getFullYear());

    function formatDate(date) {
        const day = date.getDate();
        const month = date.getMonth() + 1; // Month is zero-based, so we add 1
        const year = date.getFullYear();

        const hours = date.getHours()
        const minutes = date.getMinutes()

        // Pad day and month with leading zeros if needed
        const formattedDay = day < 10 ? `0${day}` : day;
        const formattedMonth = month < 10 ? `0${month}` : month;

        // Construct the formatted date string
        const formattedDate = `${formattedDay}-${formattedMonth}-${year}`;
        // const formattedDate = `${formattedDay}-${formattedMonth}-${year}, ${formattedHours}:${formattedMinutes}`;
        return formattedDate;
    }

    const updateFiltre = (periode, mois, annee, debut, fin, status) => {
        if (filtrerInstallation) {
            filtrerInstallation({
                periode: periode,
                mois: mois,
                annee: annee,
                debut: formatDate(debut),
                fin: formatDate(fin),
                status: status,
            });
        }
        if (filtrerChiffreAffaire) {
            filtrerChiffreAffaire({
                periode: periode,
                mois: mois,
                annee: annee,
                debut: formatDate(debut),
                fin: formatDate(fin),
                status: status,
            });
        }
        if (filtrerStatCounter) {
            filtrerStatCounter({
                periode: periode,
                mois: mois,
                annee: annee,
                debut: formatDate(debut),
                fin: formatDate(fin)
            });
        }
    };

    return (
        <>
            <div className="ml-auto lg:flex gap-x-3">
                <select
                    value={selectPeriode}
                    onChange={(e) => {
                        setSelectPeriode(e.target.value);
                        updateFiltre(e.target.value, selectMois, selectAnnee, startDate, endDate, "")
                    }}
                    className="my-2 select"
                >
                    <option value="JOUR">Periode</option>
                    <option value="MOIS">Filtre par mois</option>
                    <option value="ANNEE">Filtre par années</option>
                </select>
                {selectPeriode === "MOIS" ? (
                    <div className="flex items-center gap-x-3">
                        <select
                            value={selectMois}
                            onChange={(e) => {
                                setSelectMois(e.target.value);
                                updateFiltre(selectPeriode, e.target.value, selectAnnee, startDate, endDate, "")
                            }}
                            className="my-2 select"
                        >
                            <option disabled selected>
                                mois
                            </option>
                            {months.map((item) => (
                                <option value={item.code}>{item.name}</option>
                            ))}
                        </select>
                        <select
                            value={selectAnnee}
                            onChange={(e) => {
                                setSelectAnnee(e.target.value);
                                updateFiltre(selectPeriode, selectMois, e.target.value, startDate, endDate, "")
                            }}
                            className="my-2 select "
                        >
                            <option disabled selected>
                                années
                            </option>
                            {years.map((item) => (
                                <option
                                    value={item.name}
                                    selected={
                                        new Date().getFullYear() === Number(item.name)
                                            ? true
                                            : false
                                    }
                                >
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>
                ) : selectPeriode === "ANNEE" ? (
                    <select
                        value={selectAnnee}
                        onChange={(e) => {
                            setSelectAnnee(e.target.value);
                            updateFiltre(selectPeriode, selectMois, e.target.value, startDate, endDate, "")
                        }}
                        className="my-2 select "
                    >
                        <option disabled selected>
                            années
                        </option>
                        {years.map((item) => (
                            <option
                                value={item.name}
                                selected={
                                    new Date().getFullYear() === Number(item.name) ? true : false
                                }
                            >
                                {item.name}
                            </option>
                        ))}
                    </select>
                ) : (
                    <ReactDatePicker
                        dateFormat="dd-MM-yyyy"
                        selected={startDate}
                        onChange={(update) => {
                            if (update[1] != null) {
                                updateFiltre(selectPeriode, selectMois, selectAnnee, update[0], update[1], "")
                            }
                            setDateRange(update);
                        }}
                        startDate={startDate}
                        endDate={endDate}
                        selectsRange
                        className="text-sm font-normal cursor-pointer btn btn-sm hover:bg-gray-100 text-center h-10 my-2 w-52 rounded-md border border-input bg-gray-100 px-3 py-1 shadow-sm"
                    />
                )}
            </div>
        </>
    );
};
